// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b666a9f1","453":"0f23da72","455":"770c481d","977":"b42b7c0b"}[chunkId] + ".chunk.js";
};